import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-no-rights',
  templateUrl: './no-rights.component.html',
  styleUrl: './no-rights.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoRightsComponent {}
